import React from "react";
import ReactDOM from "react-dom";
import Route from "./components/Route/Route";
import "bootstrap/dist/css/bootstrap.min.css";

import "swiper/swiper.scss";
import "@patternfly/react-core/dist/styles/base.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./Template.css";

ReactDOM.render(
  <React.StrictMode>
    <Route />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// import 'swiper/swiper.scss';
// import "swiper/css/swiper.css";
// import 'swiper/components/navigation/navigation.scss';
// import 'swiper/components/pagination/pagination.scss';
// import 'swiper/components/scrollbar/scrollbar.scss';
